import { render, staticRenderFns } from "./ProjectMarket.vue?vue&type=template&id=be3646d6&scoped=true"
import script from "./ProjectMarket.vue?vue&type=script&lang=js"
export * from "./ProjectMarket.vue?vue&type=script&lang=js"
import style0 from "./ProjectMarket.vue?vue&type=style&index=0&id=be3646d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3646d6",
  null
  
)

export default component.exports